<template>
    <div class="DatatableDemo">
        <RPDatatable
            v-model="checked"
            :headers="headers"
            :hide-id="false"
            :table-data="tableData"
            :sort="sort"
            :sort-direction="sortDirection"
            :show-extra-options="true"
            :show-action-cell="true"
            :status="''"
            @set-sort="setSort"
        >
            <template v-slot:extraOptions="{rowId}">
                <div class="extra">
                    {{ rowId }}
                </div>
            </template>
        </RPDatatable>

        <RPDatatable
            v-model="checked"
            :headers="headers"
            :hide-id="false"
            :table-data="tableData"
            :sort="sort"
            :sort-direction="sortDirection"
            :show-extra-options="true"
            :show-action-cell="true"
            :status="'loading'"
            :limit="3"
            @set-sort="setSort"
        />

        <RPTableCard
            v-model="checkedTwo"
            :headers="headers"
            :hide-id="false"
            :table-data="tableData"
            :sort="sort"
            :sort-direction="sortDirection"
            @set-sort="setSort"
        >
            <template v-slot:nameElem="{prop, rowData}">
                {{ prop }} - {{ rowData }}
            </template>
            <template v-slot:extraOptions="{rowId}">
                <div class="extra">
                    {{ rowId }}
                </div>
            </template>
        </RPTableCard>
    </div>
</template>
<script>
import RPDatatable from 'components/Complex/RPDatatable/RPDatatable.vue';
import RPTableCard from 'components/Complex/Cards/RPTableCard.vue';

export default {
    name: 'DatatableDemo',
    components: {
        RPDatatable,
        RPTableCard
    },
    data(){
        return {
            headers: [
                {
                    label: "ID",
                    key: "id",
                },
                {
                    label: "Name",
                    key: "name",
                },
                {
                    label: "Email",
                    key: "email",
                },
                {
                    label: "Role",
                    key: "role",
                    sortable: true,
                },
            ],
            tableData: [
                {
                    id: 1,
                    name: "Test One",
                    email: "testOne@test.com",
                    role: "Test User",
                    status: 'success'
                },
                {
                    id: 2,
                    name: "Test Two",
                    email: "testTwo@test.com",
                    role: "Test User",
                    status: 'warning'
                },
                {
                    id: 3,
                    name: "Test Three",
                    email: "testThree@test.com",
                    role: "Test User",
                    status: 'error'
                }
            ],
            sort: 'role',
            sortDirection: 'asc',
            checked: '',
            checkedTwo: [],
        };
    },
    methods: {
        setSort({key, direction}){
            this.sort=key;
            this.sortDirection=direction;
        }
    }
};
</script>
<style lang="scss">
    .DatatableDemo {
        height: 100%;
        width: 100%;
        background: #E5E5E5;
        padding: 20px;
        & > * {
            margin-bottom: 2rem;
        }
    }
    .extra {
        height: 10rem;
        width: 5rem;
    }
</style>
